/**
 * @generated SignedSource<<1bc3e446831a74b4c4f1f57fc9cc305b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteConversationInput = {
  conversationId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
};
export type useLlmConversationActionsDeleteConversationMutation$variables = {
  input: DeleteConversationInput;
};
export type useLlmConversationActionsDeleteConversationMutation$data = {
  readonly deleteConversation: {
    readonly deletedConversationId: string;
    readonly success: boolean;
  };
};
export type useLlmConversationActionsDeleteConversationMutation = {
  response: useLlmConversationActionsDeleteConversationMutation$data;
  variables: useLlmConversationActionsDeleteConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteConversationPayload",
    "kind": "LinkedField",
    "name": "deleteConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedConversationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLlmConversationActionsDeleteConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLlmConversationActionsDeleteConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2443fb08e825f81a7dd0d1ce4f1c7b9a",
    "id": null,
    "metadata": {},
    "name": "useLlmConversationActionsDeleteConversationMutation",
    "operationKind": "mutation",
    "text": "mutation useLlmConversationActionsDeleteConversationMutation(\n  $input: DeleteConversationInput!\n) {\n  deleteConversation(input: $input) {\n    success\n    deletedConversationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c30d6909d858a81b14ddafee2fc290fe";

export default node;
